import Breadcrumb from '@/components/base/Breadcrumb';
import { SITE_NAME } from '@/mocks/site';

export default function AboutHero() {
  const facts = [
    { label: '站点定位', value: '赛事信息门户' },
    { label: '内容范围', value: '赛程 · 安排 · 进度' },
    { label: '更新节奏', value: '节点变更即时同步' },
  ];

  return (
    <section className="w-full px-4 md:px-6 pt-28 md:pt-36 pb-12 md:pb-16 bg-background-100">
      <div className="max-w-6xl mx-auto w-full">
        <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '关于我们' }]} />

        <span className="mt-6 inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
          <span className="w-6 h-px bg-primary-400" />
          About Us
        </span>
        <h1 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight max-w-3xl">
          关于{SITE_NAME}赛程站
        </h1>
        <p className="mt-5 max-w-3xl text-sm md:text-base text-foreground-600 leading-relaxed">
          我们只做一件事：把{SITE_NAME}的时间讲清楚。哪天截稿、哪天开投、哪天出结果，全部收在一个入口里，按日程盯紧就行，不用再到各个群里反复确认。
        </p>

        <dl className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-px bg-background-200 rounded-md overflow-hidden border border-background-200">
          {facts.map((f) => (
            <div key={f.label} className="bg-background-50 px-6 py-5">
              <dt className="text-xs text-foreground-500">{f.label}</dt>
              <dd className="mt-2 font-heading text-lg font-semibold text-foreground-950">{f.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}